<template>
  <a-menu-item :key="menusKey">
    <template v-if='!item.hidden'>
      <router-link :to='item.url'>
        <component v-if='item.icon&&item.icon!=""' :is="item.icon"></component><span>{{item.title}}</span>
      </router-link>
    </template>
  </a-menu-item>
</template>
<script>
import * as Icon from "@ant-design/icons-vue";
export default {
  name: "MenuItem",
  components: {
    ...Icon,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
    menusKey:String
  },
  data() {
    return {};
  },
};
</script>